import { USER_FCM_TOKEN_KEY } from "./../../services/local/auth-tokens";
import { all, put, takeEvery } from "redux-saga/effects";
import { ROUTE_PATH } from "../../common/constants/app.constant";
import { toggleMessage } from "../../components/Toast/Toast";
import { ILoginResponse } from "../../models/auth";
import { IBaseResponseModel } from "../../models/common/models.type";
import {
  EAuthType,
  IActionAdminLoginWithPassword,
  IActionLoginWithPassword,
  IActionLogout
} from "../../models/redux/auth";
import AuthService from "../../services/api/auth.service";
import authTokens from "../../services/local/auth-tokens";
import { clearUser } from "../user/user.duck";
import { jwtDecode } from "jwt-decode";
import { IUser } from "../../models/user";
import { envConfig } from "../../config/env.config";

function* loginWithPassword({ payload }: IActionLoginWithPassword) {
  const { loginRequest, navigate } = payload;
  try {
    const resLogin: IBaseResponseModel<string> =
      yield AuthService.loginWithPassword(loginRequest);
    if (resLogin.success) {
      const token = resLogin.data;
      const user = JSON.parse(JSON.stringify(jwtDecode(token)));
      // console.log('token-11111:', token);
      // const userInfo: IUser = {
      //   id: user.userId,
      //   code: null,
      //   firstName: user.firstName,
      //   lastName: user.lastName,
      //   fullName: user.fullName,
      //   avatar: user.avatar,
      //   email: user.email,
      //   phoneNumber: null,
      //   userName: "",
      //   roles: user.role,
      //   roleId: user.roleId,
      //   role: null,
      //   position: null,
      //   address: null,
      //   managerId: null,
      //   birthDay: null,
      //   manager: null,
      //   status: 0,
      //   departments: [],
      //   staff: [],
      //   isTimeOffStart: false,
      //   isCompany: user.isCompany,
      //   companyId: user.companyId,
      //   isSuperAdmin: user.isSupperAdmin === "True" || user.isSupperAdmin === true,
      // };

      yield authTokens.storeToken(token);
      //yield authTokens.storeUser(userInfo);
      yield authTokens.storeRole(user.roles);

      // console.log('[AUTH SAGA] loginWithPassword - Calling syncOidcSession', {
      //   userId: userInfo.id,
      //   userEmail: userInfo.email,
      //   userName: userInfo.fullName,
      //   roles: userInfo.roles,
      //   tokenPrefix: token ? token.substring(0, 20) + '...' : 'N/A',
      //   timestamp: new Date().toISOString()
      // });

      const result: IBaseResponseModel<any> =
        yield AuthService.syncOidcSession();

      const to = { pathname: ROUTE_PATH.INDEX, user: user };

      // navigate(to, { replace: true });

      const searchParams = new URLSearchParams(window.location.search);
      const isOidcLogin = searchParams.get("oidc") === "true";
      const returnUrl = searchParams.get("returnUrl");

      if (isOidcLogin && returnUrl && result.success) {
        window.location.href = `${envConfig.API_ENDPOINT.replace("/api", "")}${decodeURIComponent(returnUrl)}`;
        return;
      } else {
        navigate(to, { replace: true });
      }
    } else if (!resLogin.success) {
      toggleMessage({
        type: "error",
        message: resLogin.message ?? "Your email or password is incorrect!"
      });
    }
  } catch (err) {}
}

function* adminLoginWithPassword({ payload }: IActionAdminLoginWithPassword) {
  const { loginRequest, navigate } = payload;
  try {
    const resLogin: IBaseResponseModel<ILoginResponse> =
      yield AuthService.adminLoginWithPassword(loginRequest);
    if (resLogin.success) {
      const loginInfo = resLogin.data;

      yield authTokens.storeToken(loginInfo.token);
      // yield authTokens.storeRole(
      //   loginInfo.user.role === Roles.Admin
      //     ? Roles.AdminSystem
      //     : loginInfo.user.role
      // );

      // console.log('[AUTH SAGA] adminLoginWithPassword - Calling syncOidcSession', {
      //   loginType: 'admin',
      //   tokenPrefix: loginInfo.token ? loginInfo.token.substring(0, 20) + '...' : 'N/A',
      //   timestamp: new Date().toISOString()
      // });

      // Sync OIDC session after admin login
      try {
        const startTime = Date.now();
        const result: IBaseResponseModel<any> =
          yield AuthService.syncOidcSession();
        const endTime = Date.now();

        // if (result.success) {
        //   console.log('[AUTH SAGA] adminLoginWithPassword - OIDC sync session SUCCESS:', {
        //     success: result.success,
        //     message: result.message,
        //     data: result.data,
        //     duration: `${endTime - startTime}ms`,
        //     loginType: 'admin',
        //     timestamp: new Date().toISOString()
        //   });
        // } else {
        //   console.warn('[AUTH SAGA] adminLoginWithPassword - OIDC sync session FAILED (API returned error):', {
        //     success: result.success,
        //     message: result.message,
        //     statusCode: result.statusCode,
        //     duration: `${endTime - startTime}ms`,
        //     loginType: 'admin',
        //     timestamp: new Date().toISOString()
        //   });
        // }
      } catch (error) {
        console.error(
          "[AUTH SAGA] adminLoginWithPassword - OIDC sync session FAILED (Exception):",
          {
            error,
            errorMessage:
              error instanceof Error ? error.message : "Unknown error",
            errorResponse: (error as any)?.response?.data,
            errorStatus: (error as any)?.response?.status,
            loginType: "admin",
            timestamp: new Date().toISOString()
          }
        );
        // Ignore errors (token expired, network error, etc.)
      }

      navigate(ROUTE_PATH.INDEX, { replace: true });
    } else {
      toggleMessage({
        type: "error",
        message: "Your email or password is incorrect!"
      });
    }
  } catch (err) {}
}

function* logout({ payload }: IActionLogout) {
  const { navigate } = payload;
  try {
    const token = localStorage.getItem(USER_FCM_TOKEN_KEY);
    if (token) {
      yield AuthService.logout(token);
    }
    yield authTokens.clear();
    yield put(clearUser());

    navigate && navigate(ROUTE_PATH.LOGIN, { replace: true });
  } catch (err) {}
}

export default function* rootSaga() {
  yield all([
    takeEvery(EAuthType.LOGIN_WITH_PASSWORD, loginWithPassword),
    takeEvery(EAuthType.ADMIN_LOGIN_WITH_PASSWORD, adminLoginWithPassword),
    takeEvery(EAuthType.LOGOUT, logout)
  ]);
}
